import React from "react";
import { Container } from "react-bootstrap";
import Analyse from "../CommonForBoth/Analyse";

const Footer = () => {
  return (
    <React.Fragment>
      <Analyse />
      <footer className="footer">
        <Container fluid={true}>
          <div className="text-center">
            {new Date().getFullYear()} ©{" "}
            <a href="https://silverethics.com" target="_blank" rel="noopener noreferrer">
              Silverethics Technologies Private Limited
            </a>
            .
          </div>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
